import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const generateMeals = async (llmPrompt) => {
	const url = `${API_URL}/generate/generate-meal-plan`;
	try {
		const response = await axios.post(url, { prompt: llmPrompt });
		return response.data;
	} catch (error) {
		console.error('Error generating meal plan:', error);
		throw error;
	}
};

export const saveMealPlan = async (userId, mealPlan) => {
	const url = `${API_URL}/users/${userId}/meals`;
	try {
		const response = await axios.post(url, mealPlan);
		return response.data;
	} catch (error) {
		console.error('Error saving meal plan:', error);
		throw error;
	}
};
